import { connect } from 'react-redux';

import {
    mapDispatchToProps,
    mapStateToProps,
    ProductWishlistButtonContainer as SourceProductWishlistButtonContainer
} from 'SourceComponent/ProductWishlistButton/ProductWishlistButton.container';
import { isSignedIn } from 'Util/Auth';
import { noopFn } from 'Util/Common';
import componentLoader from 'Util/componentLoader';

export const WishlistDispatcher = componentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Wishlist/Wishlist.dispatcher'
), 2);

export {
    mapStateToProps,
    mapDispatchToProps
};

/** @namespace Bodypwa/Component/ProductWishlistButton/Container */
export class ProductWishlistButtonContainer extends SourceProductWishlistButtonContainer {
    static defaultProps = {
        mix: {},
        onProductValidationError: noopFn,
        isInGallery: false,
        hideWishlistButton: true
    };

    containerProps() {
        const {
            magentoProduct, mix, isInGallery, hideWishlistButton
        } = this.props;

        return {
            mix,
            magentoProduct,
            isDisabled: this.isDisabled(),
            isInWishlist: this.isInWishlist(),
            isSignedIn: isSignedIn(),
            isInGallery,
            hideWishlistButton
        };
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductWishlistButtonContainer);
